import React from "react";
import { connect } from "react-redux";
import axios from "axios";
import routes from "../../../assets/apiRoutes.json";
import "./MasterRecord.css";
import { Button } from 'devextreme-react/button';
import Form, {
  SimpleItem, GroupItem, ButtonItem, Label
} from 'devextreme-react/form';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { Lookup as LookupBox, DropDownOptions } from 'devextreme-react/lookup';
import { Popup } from 'devextreme-react/popup';
import ScrollView from 'devextreme-react/scroll-view';
import notify from 'devextreme/ui/notify';
import { GridLayout } from "../../../common/GridLayout";
import DataGrid, {
  Column,
  Editing,
  Selection,
  ColumnChooser,
  ColumnChooserSearch,
  HeaderFilter,
  Lookup,
  StateStoring
} from 'devextreme-react/data-grid';
import { CheckBox } from 'devextreme-react/check-box';
import TextBox from 'devextreme-react/text-box';
import DateBox from 'devextreme-react/date-box';
import { alert } from 'devextreme/ui/dialog';
import { confirm } from 'devextreme/ui/dialog';
import NumberBox from "devextreme-react/number-box";
import { HubConnectionBuilder } from "@microsoft/signalr";
import GridLayoutManager from "../../../gridLayoutCustomization/GridLayoutManager";

const dataGrid = React.createRef();
const eGermForm = React.createRef();
const productionLotSelectBox = React.createRef();

let accessToken = '';
let customSelection = false;
const gridKey = "ff394c55-e7bc-42eb-9dac-e18a500dc126";
function renderMasterOrderHeaderLabel() {
  return <p className="main-title" style={{ marginTop: '18px' }}>Master SOW Records</p>;
}


class MasterOrder extends React.Component {

  constructor(props) {
    super(props);

    this.calculateButtonOptions = {
      id: 'calculateButton',
      text: 'Calculate',
      type: 'default',
      useSubmitBehavior: true,
      onClick: this.showPopup.bind(this)
    };

    this.calculateNewIssueQty = this.calculateNewIssueQty.bind(this);
    this.applySeedsPerCell = this.applySeedsPerCell.bind(this);
    this.popupOKClick = this.popupOKClick.bind(this);
    this.eGermPopupCloseClick = this.eGermPopupCloseClick.bind(this);
    this.printTagReport = this.printTagReport.bind(this);


    this.disabledDateTimeEditorOptions = {
      type: 'datetime',
      readOnly: true
    };

    this.disabledDateEditorOptions = {
      type: 'date',
      readOnly: true
    };

    this.DateEditorOptions = {
      type: 'date',
      useMaskBehavior: true,
      showClearButton: true
    };

    this.disabledEditorOptions = {
      readOnly: true
    }

    this.requiredEditorOptions = {
      readOnly: true,
      format: "#,##0.00"
    }

    this.balanceEditorOptions = {
      readOnly: true,
      format: "#,##0.00"
    }

    this.newIssueQtyEditorOptions = {
      format: "#,##0.00"
    }

    accessToken = props.oidc.user.access_token;

    this.state = {
      plugCalculatorPopupVisible: false,
      bareRootCalculatorPopupVisible: false,
      eGermPopupVisible: false,
      isGetReportPopupVisible: false,
      isReportInProgressPopupVisible: false,
      emailLink: "mailto:someone@something.com?subject=your title&body=The message",
      order: {
        rowid: '00000000-0000-0000-0000-000000000000',
        customername: '',
        salesorder: '',
        salesorderline: 0,
        orderquantity: 0.0,
        facility: '',
        custtype: '',
        prodlot: '',
        speciescode: '',
        Lastupdatedatetime: new Date(),
        companyid: '',
        hdrcreationdate: new Date(),
        salesitem: '',
        color: '',
        symbol: '',
        comment: '',
        prodtype: '',
        species: '',
        kittstocktype: '',
        kittcells: '',
        celltype: '',
        oversow: '',
        seedsource: '',
        commonname: '',
        stratdays: 0,
        wetstratdays: 0,
        drystratdays: 0,
        seqnumber: 0,
        receiving: 0,
        soakin: '',
        treat: '',
        sowdate: new Date(),
        seedspercell: 0,
        cutseedspercell: 0,
        iscut: false,
        egerm: 0,
        salesrep: '',
        isreleased: false,
        releaseddate: new Date(),
        islotassigned: false,
        lotassigneddate: new Date(),
        isstratpending: false,
        stratpendingdate: new Date(),
        isonpullorder: false.valueOf,
        onpullorderdate: new Date(),
        pullordernumber: 0,
        isinwetstrat: false,
        inwetstratdate: new Date(),
        stratdate: new Date(),
        orderduedate: new Date(),
        endstratdate: new Date(),
        stratrowbayshelf: '',
        isselectdrylots: false,
        selectdrylotsdate: new Date(),
        selectdrylotsnumber: 0,
        drystratcomplete: false,
        drystratcompletedate: new Date(),
        isshipped: false,
        shippeddate: new Date(),
        dryStratDoneDate: new Date(),
        newwetweight: 0,
        lotcutdate: new Date(),
        newbags: 0,
        newseedslb: 0,
        fieldname: '',
        seedplantcomment: '',
        selecteddetailrowid: '00000000-0000-0000-0000-000000000000',
        selecteddetailissueqty: 0.0,
        selecteddetailchangedissueqty: 0.0,
        selecteddetailavailable: 0.0,
        selecteddetailnetavailable: 0.0,
        selecteddetailchangeqty: 0.0,
        selecteddetailnewavailable: 0.0,
        selecteddetailcurrentqty: 0.0,
        selecteddetailseeditem: '',
        selecteddetailseedlot: '',
        selecteddetailgerm: 0.0,
        selecteddetailpurity: 0.0,
        selecteddetailcellstosow: 0.0,
        selecteddetailseedslb: 0,
        selecteddetailrevseedslb: 0,
        selecteddetailpad: 0.0,
        selecteddetailrequired: 0.0,
        selecteddetailbalance: 0.0,
        newseedspercell: 0.0,
        selecteddetailnewissueqty: 0.0,
        selecteddetailplsperlb: 0,
        selecteddetailpktreeslb: 0,
        selecteddetailpktrees: 0,
        selecteddetailallpktrees: 0,
        imagedata: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIEAAACBCAIAAABowk4HAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAEwSURBVHhe7dExAQAgDMCwgX/P48FDnuapgJ7dnVD3N04PvB54PfB64PXA64HXA68HXg+8Hng98Hrg9cDrgdcDrwdeD7weeD3weuD1wOuB1wOvB14PvB54PfB64PXA64HXA68HXg+8Hng98Hrg9cDrgdcDrwdeD7weeD3weuD1wOuB1wOvB14PvB54PfB64PXA64HXA68HXg+8Hng98Hrg9cDrgdcDrwdeD7weeD3weuD1wOuB1wOvB14PvB54PfB64PXA64HXA68HXg+8Hng98Hrg9cDrgdcDrwdeD7weeD3weuD1wOuB1wOvB14PvB54PfB64PXA64HXA68HXg+8Hng98Hrg9cDrgdcDrwdeD7weeD3weuD1wOuB1wOvB14PvB54PfB64PXA64HXA23mAayHA/8b+LUIAAAAAElFTkSuQmCC',
        issueqtysum: 0.0,
        selectedseedpercell: 0.0,
        poundsperbag: 3.0,
        poundslastbag: 0.0,
        totalbags: 0
      },
      currentLayout: "Default",

    };

    this.hidePlugCalculatorPopup = this.hidePlugCalculatorPopup.bind(this);
    this.hideBareRootCalculatorPopup = this.hideBareRootCalculatorPopup.bind(this);
    this.issuedButtonClicked = this.issuedButtonClicked.bind(this);
    this.printEGermButtonClicked = this.printEGermButtonClicked.bind(this);
    this.deleteButtonClicked = this.deleteButtonClicked.bind(this);
    this.hideEGermPopup = this.hideEGermPopup.bind(this);
    this.eGermPopupShowing = this.eGermPopupShowing.bind(this);
    this.setWarehouseValue = this.setWarehouseValue.bind(this);

    const SeedSourceArr = ['Weyer Inv', 'Cust Inv', 'Cust Seed'];
    this.seedsourceEditorOptions = { items: SeedSourceArr, searchEnabled: true };

    var that = this;
    this.selectionChanged = this.selectionChanged.bind(this);
    this.initNewRow = this.initNewRow.bind(this);
    this.rowUpdated = this.rowUpdated.bind(this);
    this.rowRemoved = this.rowRemoved.bind(this);
    this.rowInserted = this.rowInserted.bind(this);
    this.editorPreparing = this.editorPreparing.bind(this);
    this.formFieldChanged = this.formFieldChanged.bind(this);
    this.eGermFormFieldChanged = this.eGermFormFieldChanged.bind(this);

    this.isReleasedChanged = this.isReleasedChanged.bind(this);
    this.releasedDateChanged = this.releasedDateChanged.bind(this);
    this.isLotAssignedChanged = this.isLotAssignedChanged.bind(this);
    this.lotAssignedDateChanged = this.lotAssignedDateChanged.bind(this);
    this.isStratPendingChanged = this.isStratPendingChanged.bind(this);
    this.stratPendingDateChanged = this.stratPendingDateChanged.bind(this);
    this.isOnPullOrderChanged = this.isOnPullOrderChanged.bind(this);
    this.onPullOrderDateChanged = this.onPullOrderDateChanged.bind(this);
    this.pullOrderNumberChanged = this.pullOrderNumberChanged.bind(this);
    this.isInWetStratChanged = this.isInWetStratChanged.bind(this);
    this.inWetStratDateChanged = this.inWetStratDateChanged.bind(this);
    this.stratRowBayShelfChanged = this.stratRowBayShelfChanged.bind(this);
    this.isSelectDryLotsChanged = this.isSelectDryLotsChanged.bind(this);
    this.selectDryLotsDateChanged = this.selectDryLotsDateChanged.bind(this);
    this.selectDryLotsNumberChanged = this.selectDryLotsNumberChanged.bind(this);
    this.dryStratCompleteChanged = this.dryStratCompleteChanged.bind(this);
    this.dryStratCompleteDateChanged = this.dryStratCompleteDateChanged.bind(this);
    this.shippedDateChanged = this.shippedDateChanged.bind(this);

    this.updateMasterOrder = this.updateMasterOrder.bind(this);
    this.handleProductionLotChanged = this.handleProductionLotChanged.bind(this);

    this.setLocationValue = this.setLocationValue.bind(this);
    this.getSeedInventory = this.getSeedInventory.bind(this);


    this.warehouseDataSource = createStore({
      loadUrl: `${window._env_.REACT_APP_APIS}/${routes.master_records.GetWarehouses}`,
      onBeforeSend: function (method, ajaxOptions) {
        ajaxOptions.headers = {
          Authorization: `Bearer ${accessToken}`
        };
      }
    });

    this.seedItemDataSource = this.seedItemDataSource.bind(this);
    this.seedLotDataSource = this.seedLotDataSource.bind(this);
    this.locationDataSource = this.locationDataSource.bind(this);

    this.productionUnitDataSource = createStore({
      loadUrl: `${window._env_.REACT_APP_APIS}/${routes.master_records.GetProductionLots}`,
      onBeforeSend: function (method, ajaxOptions) {
        ajaxOptions.headers = {
          Authorization: `Bearer ${accessToken}`
        };
      }
    });

    this.masterOrderDetailDataSource = createStore({
      key: 'rowid',
      loadParams:
      {
        masterRowId: function () {
          if (that.state != null && that.state != undefined &&
            that.state.order != null && that.state.order != undefined) {
            return that.state.order.rowid;
          }

          return "00000000-0000-0000-0000-000000000000";
        }
      },
      loadUrl: `${window._env_.REACT_APP_APIS}/${routes.master_records.GetMasterOrderDetails}`,
      insertUrl: `${window._env_.REACT_APP_APIS}/${routes.master_records.InsertOrderMasterDetail}`,
      updateUrl: `${window._env_.REACT_APP_APIS}/${routes.master_records.UpdateOrderMasterDetail}`,
      deleteUrl: `${window._env_.REACT_APP_APIS}/${routes.master_records.DeleteOrderMasterDetail}`,
      onBeforeSend: function (method, ajaxOptions) {
        ajaxOptions.headers = {
          Authorization: `Bearer ${accessToken}`
        };
      }
    });

    const newConnection = new HubConnectionBuilder()
      .withUrl(`${window._env_.REACT_APP_APIS.substring(0, window._env_.REACT_APP_APIS.length - 4)}/hubs/report`)
      .withAutomaticReconnect()
      .build();

    this.state.connection = newConnection;

    if (this.state.connection) {
      this.state.connection
        .start()
        .then((result) => {
          console.log("Connected!");

          this.state.connection.on("ReceiveMessage", (message) => {
            this.setState({
              generatedFileName: message.message,
              isGetReportPopupVisible: true,
              isReportInProgressPopupVisible: false,
            });
          });
        })
        .catch((e) => console.log("Connection failed: ", e));
    }

    this.GetOrderData('');
  }
  setCurrentLayout = (value) => {
    this.setState({
      currentLayout: value
    })
  }
  loadState = () => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, this.state.currentLayout); }
  saveState = (state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, this.state.currentLayout); }
  render() {
    return (
      <div className="h-100 m-0" style={{ height: '100vh', overflowY: 'auto', overflowX: 'hidden' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start', // Top alignment
            height: '70px',            // You can change this to whatever height you need
            backgroundColor: '#f0f1ef',
            padding: '10px',
            flexShrink: 0
          }}
        >
          {/* Title - Left Side */}
          <div>
            <h6 style={{ margin: 0, color: window._env_.Color2 }}>
              Master SOW Records
            </h6>
          </div>

          {/* Controls - Right Side */}
          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
            <LookupBox
              ref={productionLotSelectBox}
              placeholder="Production Unit"
              dataSource={this.productionUnitDataSource}
              valueExpr="prodlot"
              displayExpr="bareRootPickList"
              onValueChanged={this.handleProductionLotChanged}
              searchEnabled={true}
              showClearButton={true}
              width={300}
            >
              <DropDownOptions hideOnOutsideClick={true} width={500} />
            </LookupBox>

            <img
              src={this.state.order.imagedata}
              height="50"
              width="50"
              alt="order"
              style={{ objectFit: 'cover' }}
            />

            <Button icon="print" onClick={this.printReport} />
            <Button icon="remove" onClick={this.deleteButtonClicked} />
            <Button
              text="Issued"
              type="default"
              onClick={this.issuedButtonClicked}
            />
            <NumberBox
              value={this.state.order.issueqtysum}
              format="#,##0.00"
              height="50"
              width="80"
              readOnly={true}
            />
            <label
              style={{
                color: 'black',
                fontWeight: 'bold',
                lineHeight: '50px'
              }}
            >
              Lbs
            </label>
          </div>
        </div>

        <div className="row" style={{ backgroundColor: 'white' }}>
          <div className="col-md-9">
            <Form
              id="form"
              labelMode="static"
              labelLocation="left"
              formData={this.state.order}
              minColWidth={100}
              colCount={1}
              onFieldDataChanged={this.formFieldChanged}
              style={{ marginTop: '5px' }}>
              <GroupItem caption="Order Information" colCount={2}>
                <GroupItem>
                  <SimpleItem dataField="customername" editorOptions={this.disabledEditorOptions}><Label text="Customer Name"></Label></SimpleItem>
                  <GroupItem colCount={3}>
                    <SimpleItem dataField="salesorder" editorOptions={this.disabledEditorOptions}><Label text="Sales Order"></Label></SimpleItem>
                    <SimpleItem dataField="salesorderline" editorOptions={this.disabledEditorOptions}><Label text="Line"></Label></SimpleItem>
                    <SimpleItem dataField="orderquantity" editorOptions={this.disabledEditorOptions}><Label text="Order Qty"></Label></SimpleItem>
                  </GroupItem>
                  <GroupItem>
                    <SimpleItem dataField="salesrep" editorOptions={this.disabledEditorOptions}><Label text="Sales Rep"></Label></SimpleItem>
                  </GroupItem>
                  <GroupItem>
                    <SimpleItem dataField="lastupdatedatetime" editorType="dxDateBox" editorOptions={this.disabledDateTimeEditorOptions}><Label text="Lines Date Modified"></Label></SimpleItem>
                  </GroupItem>
                  <GroupItem>
                    <SimpleItem dataField="hdrcreationdate" editorType="dxDateBox" editorOptions={this.disabledDateTimeEditorOptions}><Label text="Order Creation Date"></Label></SimpleItem>
                  </GroupItem>
                  <GroupItem colCount={3}>
                    <SimpleItem dataField="facility" editorOptions={this.disabledEditorOptions}><Label text="SOW Facility"></Label></SimpleItem>
                    <SimpleItem dataField="prodtype" editorOptions={this.disabledEditorOptions}><Label text="Prod Type"></Label></SimpleItem>
                    <SimpleItem dataField="kittstocktype" editorOptions={this.disabledEditorOptions}><Label text="Class"></Label></SimpleItem>
                  </GroupItem>
                  <GroupItem colCount={2}>
                    <SimpleItem dataField="species" editorOptions={this.disabledEditorOptions}><Label text="Species"></Label></SimpleItem>
                    <SimpleItem dataField="kittcells" editorOptions={this.disabledEditorOptions}><Label text="Cell Size"></Label></SimpleItem>
                  </GroupItem>
                </GroupItem>
                <GroupItem>
                  <GroupItem colCount={2}>
                    <SimpleItem dataField="facility" editorOptions={this.disabledEditorOptions}><Label text="SOW Facility"></Label></SimpleItem>
                    <SimpleItem dataField="custtype" editorOptions={this.disabledEditorOptions}><Label text="Type"></Label></SimpleItem>
                  </GroupItem>
                  <GroupItem>
                    <SimpleItem dataField="prodlot" editorOptions={this.disabledEditorOptions}><Label text="Prod Lot"></Label></SimpleItem>
                  </GroupItem>
                  <GroupItem colCount={2}>
                    <SimpleItem dataField="color"><Label text="Color"></Label></SimpleItem>
                    <SimpleItem dataField="symbol"><Label text="Symbol"></Label></SimpleItem>
                  </GroupItem>
                  <GroupItem>
                    <SimpleItem dataField="salesitem" editorOptions={this.disabledEditorOptions}><Label text="Item"></Label></SimpleItem>
                  </GroupItem>
                  <GroupItem colCount={2}>
                    <SimpleItem dataField="comment"><Label text="Comment"></Label></SimpleItem>
                    <SimpleItem dataField="seedplantcomment"><Label text="Seed Plant Comment"></Label></SimpleItem>
                  </GroupItem>
                  <GroupItem colCount={2}>
                    <SimpleItem dataField="celltype"><Label text="Stock Type"></Label></SimpleItem>
                    <SimpleItem dataField="oversow"><Label text="Over Sow"></Label></SimpleItem>
                  </GroupItem>
                  <GroupItem colCount={2}>
                    <SimpleItem dataField="orderquantity"><Label text="Order Qty"></Label></SimpleItem>
                    <SimpleItem dataField="seedsource" editorType="dxSelectBox" editorOptions={this.seedsourceEditorOptions}><Label text="Seed Source"></Label></SimpleItem>
                  </GroupItem>
                </GroupItem>
              </GroupItem>
              <GroupItem caption="E-Germ Calculation" colCount={5}>
                <GroupItem>
                  <SimpleItem dataField="newwetweight"><Label text="Net Wet Lbs"></Label></SimpleItem>
                  <SimpleItem dataField="lotcutdate" editorType="dxDateBox" editorOptions={this.DateEditorOptions}><Label text="Lot Cut Date"></Label></SimpleItem>
                </GroupItem>
                <GroupItem>
                  <SimpleItem dataField="newbags"><Label text="New Bags"></Label></SimpleItem>
                  <SimpleItem dataField="newseedslb"><Label text="New Seeds/Lb"></Label></SimpleItem>
                </GroupItem>
                <GroupItem>
                  <SimpleItem dataField="seedspercell"><Label text="OS/Cell"></Label></SimpleItem>
                  <SimpleItem dataField="cutseedspercell"><Label text="CS/Cell"></Label></SimpleItem>
                </GroupItem>
                <GroupItem>
                  <SimpleItem dataField="egerm"><Label text="E-Germ"></Label></SimpleItem>
                  <SimpleItem dataField="iscut"><Label text="Is Cut"></Label></SimpleItem>
                </GroupItem>
                <GroupItem>
                  <Button icon="print" onClick={this.printEGermButtonClicked} />
                </GroupItem>
              </GroupItem>
              <GroupItem colCount={3}>
                <GroupItem caption="Transaction" colCount={2}>
                  <GroupItem>
                    <SimpleItem dataField="selecteddetailnetavailable"><Label text="Net Available"></Label></SimpleItem>
                    <SimpleItem dataField="selecteddetailavailable"><Label text="Available"></Label></SimpleItem>
                    <SimpleItem dataField="selecteddetailcurrentqty"><Label text="Current Qty"></Label></SimpleItem>
                    <SimpleItem dataField="selecteddetailchangedissueqty"><Label text="Issue Qty"></Label></SimpleItem>
                  </GroupItem>
                  <GroupItem>
                    <SimpleItem dataField="selecteddetailchangeqty"><Label text="Change Qty"></Label></SimpleItem>
                    <SimpleItem dataField="selecteddetailnewavailable"><Label text="New Available"></Label></SimpleItem>
                    <GroupItem>
                      <ButtonItem id="calculatebutton" horizontalAlignment="left" buttonOptions={this.calculateButtonOptions} />
                    </GroupItem>
                  </GroupItem>
                </GroupItem>
                <GroupItem caption="Handling">
                  <SimpleItem dataField="genusspecies" editorOptions={this.disabledEditorOptions}><Label text="Genus"></Label></SimpleItem>
                  <GroupItem colCount={2}>
                    <GroupItem>
                      <SimpleItem dataField="commonname" editorOptions={this.disabledEditorOptions}><Label text="Species Name"></Label></SimpleItem>
                      <SimpleItem dataField="speciescode" editorOptions={this.disabledEditorOptions}><Label text="Species"></Label></SimpleItem>
                      <SimpleItem dataField="stratdays" editorOptions={this.disabledEditorOptions}><Label text="Strat Days"></Label></SimpleItem>
                      <SimpleItem dataField="wetstratdays"><Label text="Wet Days"></Label></SimpleItem>
                      <SimpleItem dataField="drystratdays"><Label text="Dry Days"></Label></SimpleItem>
                    </GroupItem>
                    <GroupItem>
                      <SimpleItem dataField="species"><Label text="Species Code"></Label></SimpleItem>
                      <SimpleItem dataField="seqnumber"><Label text="Seq #"></Label></SimpleItem>
                      <SimpleItem dataField="receiving" editorOptions={this.disabledEditorOptions}><Label text="Receiving"></Label></SimpleItem>
                      <SimpleItem dataField="soakin" editorOptions={this.disabledEditorOptions}><Label text="Soak In"></Label></SimpleItem>
                      <SimpleItem dataField="treat" editorOptions={this.disabledEditorOptions}><Label text="Treat"></Label></SimpleItem>
                    </GroupItem>
                  </GroupItem>
                </GroupItem>
                <GroupItem caption="Timeline" >
                  <SimpleItem dataField="stratdate" editorType="dxDateBox" editorOptions={this.disabledDateEditorOptions}><Label text="Strat Date"></Label></SimpleItem>
                  <SimpleItem dataField="endstratdate" editorType="dxDateBox" editorOptions={this.disabledDateEditorOptions}><Label text="End Date"></Label></SimpleItem>
                  <SimpleItem dataField="sowdate" editorType="dxDateBox"><Label text="Sow Date"></Label></SimpleItem>
                  <SimpleItem dataField="orderduedate" editorType="dxDateBox" editorOptions={this.disabledDateEditorOptions}><Label text="Order Due"></Label></SimpleItem>
                </GroupItem>
              </GroupItem>
            </Form>

          </div>
          <div className="col-md-3" style={{ paddingTop: '10px' }}>
            <h6>Order Status</h6>
            <div className="mt-2">
              <div>Released</div>
              <div className="d-flex">
                <div className="col-md-2 mt-2 px-0 pt-2">
                  <CheckBox value={this.state.order.isreleased} text="" className="mr-2" onValueChanged={this.isReleasedChanged}></CheckBox>
                </div>
                <div className="col-md-10">
                  <DateBox
                    type="date"
                    useMaskBehavior={true}
                    value={this.state.order.releaseddate} onValueChanged={this.releasedDateChanged} />
                </div>
              </div>
            </div>
            <div className="mt-2">
              <div>Lot Assigned</div>
              <div className="d-flex">
                <div className="col-md-2 mt-2 px-0 pt-2">
                  <CheckBox value={this.state.order.islotassigned} text="" className="mr-2" onValueChanged={this.isLotAssignedChanged} ></CheckBox>
                </div>
                <div className="col-md-10">
                  <DateBox
                    type="date"
                    useMaskBehavior={true}
                    value={this.state.order.lotassigneddate} onValueChanged={this.lotAssignedDateChanged} />
                </div>
              </div>
            </div>
            <div className="mt-2">
              <div>Strat Pending</div>
              <div className="d-flex">
                <div className="col-md-2 mt-2 px-0 pt-2">
                  <CheckBox value={this.state.order.isstratpending} text="" className="mr-2" onValueChanged={this.isStratPendingChanged} ></CheckBox>
                </div>
                <div className="col-md-10">
                  <DateBox
                    type="date"
                    useMaskBehavior={true}
                    value={this.state.order.stratpendingdate} onValueChanged={this.stratPendingDateChanged} />
                </div>
              </div>
            </div>
            <div className="mt-2">
              <div>On Pull Order</div>
              <div className="d-flex">
                <div className="col-md-2 mt-2 px-0 pt-2">
                  <CheckBox value={this.state.order.isonpullorder} text="" className="mr-2" onValueChanged={this.isOnPullOrderChanged}></CheckBox>
                </div>
                <div className="col-md-10">
                  <DateBox
                    type="date"
                    useMaskBehavior={true}
                    value={this.state.order.onpullorderdate} onValueChanged={this.onPullOrderDateChanged} />
                </div>
              </div>
              <div className="d-flex">
                <div className="col-md-2 mt-2 px-0 pt-2">
                  <label className="mt-2">Pull #</label>
                </div>
                <div className="col-md-10">
                  <TextBox value={this.state.order.pullordernumber == null ? '' : this.state.order.pullordernumber.toString()} onValueChanged={this.pullOrderNumberChanged} />
                </div>
              </div>
            </div>
            <div className="mt-2">
              <div>In Wet Strat</div>
              <div className="d-flex">
                <div className="col-md-2 mt-2 px-0 pt-2">
                  <CheckBox value={this.state.order.isinwetstrat} text="" className="mr-2" onValueChanged={this.isInWetStratChanged} />
                </div>
                <div className="col-md-10">
                  <DateBox
                    type="date"
                    useMaskBehavior={true}
                    value={this.state.order.inwetstratdate} onValueChanged={this.inWetStratDateChanged} />
                </div>
              </div>
              <div className="d-flex">
                <div className="col-md-2 mt-2 px-0 pt-2">
                  <label className="mt-2">R.B.S#</label>
                </div>
                <div className="col-md-10">
                  <TextBox value={this.state.order.stratrowbayshelf} onValueChanged={this.stratRowBayShelfChanged} />
                </div>
              </div>
            </div>
            <div className="mt-2">
              <div>In Dry Strat</div>
              <div className="d-flex">
                <div className="col-md-2 mt-2 px-0 pt-2">
                  <CheckBox value={this.state.order.isselectdrylots} text="" className="mr-2" onValueChanged={this.isSelectDryLotsChanged} />
                </div>
                <div className="col-md-10">
                  <DateBox
                    type="date"
                    useMaskBehavior={true}
                    value={this.state.order.selectdrylotsdate} onValueChanged={this.selectDryLotsDateChanged} />
                </div>
              </div>
              <div className="d-flex">
                <div className="col-md-2 mt-2 px-0 pt-2">
                  <label className="mt-2">Dry #</label>
                </div>
                <div className="col-md-10">
                  <TextBox value={this.state.order.selectdrylotsnumber == null ? '' : this.state.order.selectdrylotsnumber.toString()} onValueChanged={this.selectDryLotsNumberChanged} />
                </div>
              </div>
            </div>
            <div className="mt-2">
              <div>Strat Out Date</div>
              <div className="d-flex">
                <div className="col-md-2"></div>
                <div className="col-md-10">
                  <DateBox
                    type="date"
                    useMaskBehavior={true}
                    readOnly={true}
                    value={this.state.order.drystratdonedate} />
                </div>
              </div>
              <div className="mt-2">
                <div>Strat Complete</div>
                <div className="d-flex">
                  <div className="col-md-2 mt-2 px-0 pt-2">
                    <CheckBox value={this.state.order.drystratcomplete} text="" className="mr-2" onValueChanged={this.dryStratCompleteChanged} />
                  </div>
                  <div className="col-md-10">
                    <DateBox
                      type="date"
                      useMaskBehavior={true}
                      value={this.state.order.drystratcompletedate} onValueChanged={this.dryStratCompleteDateChanged} />
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-2">
              <div>Shipped</div>
              <div className="d-flex">
                <div className="col-md-2 mt-2 px-0 pt-2">
                  <CheckBox value={this.state.order.isshipped} text="" className="mr-2" onValueChanged={this.isShippedChanged} />
                </div>
                <div className="col-md-10">
                  <DateBox
                    type="date"
                    useMaskBehavior={true}
                    value={this.state.order.shippeddate} onValueChanged={this.shippedDateChanged} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }} id="gridContainer"
          dataSource={this.masterOrderDetailDataSource}
          ref={dataGrid}
          showBorders={true}
          className="customDataTableDesign"
          onSelectionChanged={this.selectionChanged}
          onInitNewRow={this.initNewRow}
          onEditorPreparing={this.editorPreparing}
          onRowUpdated={this.rowUpdated}
          onRowRemoved={this.rowRemoved}
          onRowInserted={this.rowInserted}
          rowAlternationEnabled={true}
          allowColumnReordering={true}
          allowColumnResizing={true}
          columnAutoWidth={true}>
          <Selection mode="multiple" allowSelectAll={false} />
          <ColumnChooser
            enabled={true}
            title="Choose Column"
            width={290}
            height={290}
            sortOrder="asc"
          >
            <ColumnChooserSearch
              enabled={true}
              editorOptions={{ placeholder: 'Search column' }} />
          </ColumnChooser>
          <StateStoring
            enabled={true}
            type="custom"
            customLoad={this.loadState}
            storageKey={gridKey}
            customSave={this.saveState}
          />
          <HeaderFilter visible={true} />
          <Editing
            mode="cell"
            newRowPosition="last"
            refreshMode="repaint"
            allowUpdating={true}
            allowAdding={true}
            allowDeleting={true} />
          <Column dataField="warehouse" caption="Warehouse" setCellValue={this.setWarehouseValue}>
            <Lookup dataSource={this.warehouseDataSource} displayExpr="name" valueExpr="name" allowClearing={true} />
          </Column>
          <Column dataField="seeditem" caption="Seed Item" setCellValue={this.setSeedItemValue}>
            <Lookup dataSource={this.seedItemDataSource} displayExpr="name" valueExpr="name" allowClearing={true} />
          </Column>
          <Column dataField="seedlot" caption="Seed Lot" setCellValue={this.setSeedLotValue}>
            <Lookup dataSource={this.seedLotDataSource} displayExpr="name" valueExpr="name" allowClearing={true} />
          </Column>
          <Column dataField="location" caption="Location" setCellValue={this.setLocationValue}>
            <Lookup dataSource={this.locationDataSource} valueExpr="location" displayExpr="location" allowClearing={true} />
          </Column>
          <Column dataField="issueqty" dataType="number" caption="Issue Quantity" />
          <Column dataField="growingservice" dataType="boolean" caption="GroSrv" />



          <Column dataField="germ" dataType="number" caption="Germ" />
          <Column dataField="purity" dataType="number" caption="Purity" />
          <Column dataField="seedslb" dataType="number" caption="Seeds/Lb" />
          <Toolbar>
            <Item location="after">
              <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={this.setCurrentLayout} />
            </Item>
            <Item name="addRowButton" />
            <Item name="columnChooserButton" />
          </Toolbar>
        </DataGrid>

        <Popup
          visible={this.state.plugCalculatorPopupVisible}
          onHiding={this.hidePlugCalculatorPopup}
          dragEnabled={false}
          hideOnOutsideClick={true}
          showCloseButton={true}
          showTitle={true}
          title="Calculator Plug"
          container=".dx-viewport"
          closeOnOutsideClick={true}
          width={500}
          height={660}
        >
          {/* <ScrollView width="100%" height="100%"> */}
          <Form
            id="calculatePlugForm"
            labelMode="static"
            labelLocation="left"
            formData={this.state.order}
            minColWidth={100}
            colCount={2}>
            <SimpleItem dataField="speciescode" editorOptions={this.disabledEditorOptions}><Label text="Spec Code"></Label></SimpleItem>
            <SimpleItem dataField="orderquantity" editorOptions={this.disabledEditorOptions}><Label text="Order Qty"></Label></SimpleItem>
            <SimpleItem dataField="selecteddetailseeditem" editorOptions={this.disabledEditorOptions}><Label text="Seed Item"></Label></SimpleItem>
            <SimpleItem dataField="selecteddetailpad" editorOptions={this.disabledEditorOptions}><Label text="Pad"></Label></SimpleItem>
            <SimpleItem dataField="selecteddetailseedlot" editorOptions={this.disabledEditorOptions}><Label text="Seed Lot"></Label></SimpleItem>
            <SimpleItem dataField="oversow" editorOptions={this.disabledEditorOptions}><Label text="Oversow"></Label></SimpleItem>
            <SimpleItem dataField="selecteddetailgerm" editorOptions={this.disabledEditorOptions}><Label text="Germ"></Label></SimpleItem>
            <SimpleItem dataField="selectedseedpercell" editorOptions={this.balanceEditorOptions}><Label text="Seed-Cell"></Label></SimpleItem>
            <SimpleItem dataField="selecteddetailpurity" editorOptions={this.disabledEditorOptions}><Label text="Purity"></Label></SimpleItem>
            <SimpleItem dataField="selecteddetailcellstosow" editorOptions={this.disabledEditorOptions}><Label text="Cells-Sow"></Label></SimpleItem>
            <SimpleItem dataField="selecteddetailseedslb" editorOptions={this.disabledEditorOptions}><Label text="Seeds-LB"></Label></SimpleItem>
            <SimpleItem dataField="selecteddetailrequired" editorOptions={this.requiredEditorOptions}><Label text="Required"></Label></SimpleItem>
            <SimpleItem dataField="selecteddetailrevseedslb" editorOptions={this.disabledEditorOptions}><Label text="Rev - S/LB"></Label></SimpleItem>
            <SimpleItem dataField="celltype" editorOptions={this.disabledEditorOptions}><Label text="Cell Type"></Label></SimpleItem>
            <SimpleItem dataField="selecteddetailissueqty" editorOptions={this.disabledEditorOptions}><Label text="Issue Qty"></Label></SimpleItem>
            <SimpleItem dataField="selecteddetailbalance" editorOptions={this.balanceEditorOptions}><Label text="Balance"></Label></SimpleItem>
            <SimpleItem dataField="newseedspercell" editorOptions={this.newIssueQtyEditorOptions}><Label text="New Seed-Cell"></Label></SimpleItem>
            <SimpleItem dataField="selecteddetailnewissueqty" editorOptions={this.newIssueQtyEditorOptions}><Label text="New Issue Qty"></Label></SimpleItem>
          </Form>
          <div>
            <Button text="Calculate" type="default" onClick={this.calculateNewIssueQty}></Button>
            <Button text="Apply" type="default" onClick={this.applySeedsPerCell} style={{ marginLeft: '10px' }}></Button>
            <a href={this.state.emailLink}>
              <Button text="Send" icon="email" type="default" style={{ marginLeft: '10px' }}></Button>
            </a>
            <Button text="OK" type="default" onClick={this.popupOKClick} style={{ marginLeft: '10px' }}></Button>
          </div>
          {/* </ScrollView> */}

        </Popup>
        <Popup
          visible={this.state.bareRootCalculatorPopupVisible}
          onHiding={this.hideBareRootCalculatorPopup}
          dragEnabled={false}
          hideOnOutsideClick={true}
          showCloseButton={true}
          showTitle={true}
          title="Calculate Bare Root"
          container=".dx-viewport"
          closeOnOutsideClick={true}
          width={500}
          height={570}
        >
          <Form
            id="calculateBareRootForm"
            labelMode="static"
            labelLocation="left"
            formData={this.state.order}
            minColWidth={100}
            colCount={2}>
            <SimpleItem dataField="speciescode" editorOptions={this.disabledEditorOptions}><Label text="Spec Code"></Label></SimpleItem>
            <SimpleItem dataField="orderquantity" editorOptions={this.disabledEditorOptions}><Label text="Order Qty"></Label></SimpleItem>
            <SimpleItem dataField="selecteddetailseeditem" editorOptions={this.disabledEditorOptions}><Label text="Seed Item"></Label></SimpleItem>
            <SimpleItem dataField="oversow" editorOptions={this.disabledEditorOptions}><Label text="Oversow"></Label></SimpleItem>
            <SimpleItem dataField="selecteddetailseedlot" editorOptions={this.disabledEditorOptions}><Label text="Seed Lot"></Label></SimpleItem>
            <SimpleItem dataField="selecteddetailplsperlb" editorOptions={this.disabledEditorOptions}><Label text="PLS per LB"></Label></SimpleItem>
            <SimpleItem dataField="selecteddetailgerm" editorOptions={this.disabledEditorOptions}><Label text="Germ"></Label></SimpleItem>
            <SimpleItem dataField="selecteddetailpktreeslb" editorOptions={this.disabledEditorOptions}><Label text="PK Trees LB"></Label></SimpleItem>
            <SimpleItem dataField="selecteddetailpurity" editorOptions={this.disabledEditorOptions}><Label text="Purity"></Label></SimpleItem>
            <SimpleItem dataField="selecteddetailpktrees" editorOptions={this.disabledEditorOptions}><Label text="PK Trees"></Label></SimpleItem>
            <SimpleItem dataField="selecteddetailseedslb" editorOptions={this.disabledEditorOptions}><Label text="Seeds-LB"></Label></SimpleItem>
            <SimpleItem dataField="selecteddetailrequired" editorOptions={this.requiredEditorOptions}><Label text="Required"></Label></SimpleItem>
            <SimpleItem dataField="selecteddetailissueqty" editorOptions={this.disabledEditorOptions}><Label text="Issue Qty"></Label></SimpleItem>
            <SimpleItem dataField="selecteddetailallpktrees" editorOptions={this.disabledEditorOptions}><Label text="All PK Trees"></Label></SimpleItem>
          </Form>
          <div>
            <a href={this.state.emailLink}>
              <Button text="Send" icon="email" type="default"></Button>
            </a>
            <Button text="OK" type="default" onClick={this.popupOKClick} style={{ marginLeft: '10px' }}></Button>
          </div>



        </Popup>
        <Popup
          visible={this.state.eGermPopupVisible}
          onHiding={this.hideEGermPopup}
          onShowing={this.eGermPopupShowing}
          dragEnabled={false}
          hideOnOutsideClick={true}
          showCloseButton={true}
          showTitle={true}
          title="E-Germ"
          container=".dx-viewport"
          closeOnOutsideClick={true}
          width={500}
          height={650}
        >
          <ScrollView width="100%" height="100%">
            <Form
              id="eGermForm"
              ref={eGermForm}
              labelMode="static"
              labelLocation="left"
              onFieldDataChanged={this.eGermFormFieldChanged}
              formData={this.state.order}
              minColWidth={100}
              colCount={2}>
              <SimpleItem dataField="customername" editorOptions={this.disabledEditorOptions}><Label text="Customer Name"></Label></SimpleItem>
              <SimpleItem dataField="orderquantity" editorOptions={this.disabledEditorOptions}><Label text="Order Quantity"></Label></SimpleItem>
              <SimpleItem dataField="prodlot" editorOptions={this.disabledEditorOptions}><Label text="Production Lot"></Label></SimpleItem>
              <SimpleItem dataField="newwetweight" editorOptions={this.disabledEditorOptions}><Label text="New Wet Pounds"></Label></SimpleItem>
              <SimpleItem dataField="salesitem" editorOptions={this.disabledEditorOptions}><Label text="Sales Item"></Label></SimpleItem>
              <SimpleItem dataField="poundsperbag"><Label text="Pounds per Bag"></Label></SimpleItem>
              <SimpleItem dataField="species" editorOptions={this.disabledEditorOptions}><Label text="Species"></Label></SimpleItem>
              <SimpleItem dataField="poundslastbag"><Label text="Pounds last Bag"></Label></SimpleItem>
              <SimpleItem dataField="speciescode" editorOptions={this.disabledEditorOptions}><Label text="Species Code"></Label></SimpleItem>
              <SimpleItem dataField="totalbags"><Label text="Number of Bags"></Label></SimpleItem>
              <SimpleItem dataField="color" editorOptions={this.disabledEditorOptions}><Label text="Color"></Label></SimpleItem>
              <SimpleItem dataField="pullordernumber" editorOptions={this.disabledEditorOptions}><Label text="Pull Order Numnber"></Label></SimpleItem>
              <SimpleItem dataField="symbol" editorOptions={this.disabledEditorOptions}><Label text="Symbol"></Label></SimpleItem>
              <SimpleItem dataField="iscut" editorOptions={this.disabledEditorOptions}><Label text="Is Cut"></Label></SimpleItem>
              <SimpleItem dataField="cutseedspercell" editorOptions={this.disabledEditorOptions}><Label text="Cut Seeds/Cell"></Label></SimpleItem>
            </Form>
            <div>
              <Button text="Print Tags" type="default" onClick={this.printTagReport} style={{ marginLeft: '10px' }}></Button>
              <Button text="Close" onClick={this.eGermPopupCloseClick} style={{ marginLeft: '10px' }}></Button>
            </div>

          </ScrollView>

        </Popup>
        <Popup
          width={450}
          height={160}
          showTitle={false}
          title="Generate Report!"
          dragEnabled={false}
          hideOnOutsideClick={true}
          visible={this.state.isGetReportPopupVisible}
          contentRender={this.renderPopup}
        />
        <Popup
          width={450}
          height={160}
          showTitle={false}
          title="Generate Report!"
          dragEnabled={false}
          hideOnOutsideClick={true}
          visible={this.state.isReportInProgressPopupVisible}
          contentRender={this.renderReportInProgressPopup}
        />
      </div>
    );
  }

  download = () => {
    var url = `${window._env_.REACT_APP_APIS}/${routes.reports.GetReportFile}?fileName=${this.state.generatedFileName}`;

    const link = document.createElement("a");
    link.href = url;
    link.download = this.state.generatedFileName;
    link.click();
  };

  renderPopup = () => {
    return (
      <div>
        <h6 style={{ color: "#76b4ea" }}>Generate Report</h6>
        <p>Report has been generated Successfully Click View Report To See!.</p>
        <Button onClick={this.closeGetReportPopup} className="report-btn">
          Close
        </Button>
        <Button onClick={this.download} className="report-btn ml-3">
          Download Report
        </Button>
      </div>
    );
  };

  renderReportInProgressPopup = () => {
    return (
      <div>
        <h6 style={{ color: "#76b4ea" }}>Generate Report</h6>
        <p>Report generation is in progess ...</p>
        <Button
          onClick={this.closeReportInProgressPopup}
          className="report-btn"
        >
          Close
        </Button>
      </div>
    );
  };

  closeGetReportPopup = () => {
    this.setState({
      isGetReportPopupVisible: false,
      isReportInProgressPopupVisible: false,
    });
  };

  closeReportInProgressPopup = () => {
    this.setState({
      isReportInProgressPopupVisible: false,
    });
  };

  calculateNewIssueQty() {
    var cellsToSow = (this.state.order.orderquantity * this.state.order.oversow);
    var order = { ...this.state.order };
    order.selecteddetailnewissueqty = (((cellsToSow * this.state.order.newseedspercell) * this.state.order.selecteddetailpad) / this.state.order.selecteddetailrevseedslb);
    this.setState({ order });
  }

  applySeedsPerCell() {
    var that = this;
    let result = confirm("<i>Update the Master Record?</i>", "Update Master Record");
    result.then((dialogResult) => {
      if (dialogResult) {
        var order = { ...this.state.order }
        order.seedspercell = this.state.order.newseedspercell;
        this.setState({ order });
        this.updateMasterOrder("seedspercell");


      }
    });
  }

  printReport = () => {

    var report = new Object();
    report.Name = "SOR0018";
    report.IgnoreFormat = true;
    var whereInfo = new Object();
    whereInfo.FieldType = 0; //ParameterTypeEnum.String;
    whereInfo.FieldName = "RowId";
    whereInfo.Operation = 3; //OperationEnum.Equal
    whereInfo.Origin = "SOMASTERDATABASE.ROWID";
    whereInfo.From = this.state.order.rowid;
    report.FilterWhereInfoList = [];
    report.FilterWhereInfoList.push(whereInfo);
    axios.post
      (
        `${window._env_.REACT_APP_APIS}/${routes.reports.GenerateReport}`,
        report,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          },
        }
      ).then((res) => {
        if (window._env_.Generate_Report_From_Remote) {
          if (res.data.isSuccess) {
            this.setState({
              isGetReportPopupVisible: false,
              isReportInProgressPopupVisible: true,
            });

          }
          else {
            alert("Cannot generate report. Error:  " + res.data.errorMessage, "Error");
          }

        }
        else {
          if (res.hasOwnProperty('data') && res.data != null && res.data != undefined) {
            if (res.data.isSuccess) {
              window.open(`${window._env_.REACT_APP_APIS}/${routes.reports.GetReportFile}?fileName=${res.data.fileName}`, '_blank');
            }
            else {
              alert("Cannot generate report. Error:  " + res.data.errorMessage, "Error");
            }
          }
          else {
            alert("Cannot generate report", "Error");
          }
        }
      })
      .catch((err) => {
        console.log(err, "Error in Printing Master Record report.");
      });

  };


  issuedButtonClicked() {
    let request = { key: this.state.order.rowid };
    axios.put
      (
        `${window._env_.REACT_APP_APIS}/${routes.master_records.IssueMasterOrder}`,
        request,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          },
        }
      )
      .then((res) => {
        if (res.hasOwnProperty('data') && res.data != null && res.data != undefined) {
          var order = { ...this.state.order }
          order.islotassigned = res.data.islotassigned;
          order.lotassigneddate = res.data.lotassigneddate;
          this.setState({ order });

          alert("Master Order Issued", "Information");
        }
        else {
          alert("Cannot issue Master Order", "Error");
        }
      })
      .catch((err) => {
        alert(err, "Error");
      });

  }

  deleteButtonClicked() {
    alert("Seed must be returned and the record removed before you can delete this record.", "Warning")
      .then(() => {
        let result = confirm("<i>If no seed issued, delete lot select record and this record?</i>", "Delete Record");
        result.then((dialogResult) => {
          if (dialogResult) {
            axios.post
              (
                `${window._env_.REACT_APP_APIS}/${routes.master_records.DeleteMasterOrder}`,
                this.state.order,
                {
                  headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                  },
                }
              )
              .then((res) => {
                productionLotSelectBox.current.instance().reset();
                this.GetOrderData('');
              })
              .catch((err) => {
                alert(err, "Error");
              });

          }
        });
      });
  }

  printEGermButtonClicked() {
    this.setState({
      eGermPopupVisible: true
    });

  }

  eGermPopupCloseClick() {
    this.setState({
      eGermPopupVisible: false
    });
  }

  printTagReport() {
    var that = this;
    var request = new Object();
    request.rowid = this.state.order.rowid;
    request.poundsperbag = this.state.order.poundsperbag;
    request.poundslastbag = this.state.order.poundslastbag;
    request.totalbags = this.state.order.totalbags;
    request.screenName = 'MasterRecords';
    axios.post
      (
        `${window._env_.REACT_APP_APIS}/${routes.master_records.GenerateBagTagsReport}`, request,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          },
        }
      )
      .then((res) => {
        if (res.data.isSuccess) {
          window.open(
            `${window._env_.REACT_APP_APIS}/${routes.reports.GetReportFile}?fileName=${res.data.fileName}`,
            "_blank"
          );
        }

        that.setState({
          eGermPopupVisible: false
        });

      })
      .catch((err) => {
        alert(err, "Error");
      });
  }

  popupOKClick() {
    var request = {
      masterrowid: this.state.order.rowid,
      masterxrefrowid: this.state.order.selecteddetailrowid,
      seeditem: this.state.order.selecteddetailseeditem,
      seedlot: this.state.order.selecteddetailseedlot,
      issueqty: this.state.order.selecteddetailissueqty,
      residual: (this.state.order.prodtype !== "BR" ? this.state.order.selecteddetailbalance : this.state.order.selecteddetailrequired)
    }
    axios.post
      (
        `${window._env_.REACT_APP_APIS}/${routes.master_records.InsertResidualSeedIssued}`,
        request,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          },
        }
      )
      .then((res) => {
        if (this.state.order.prodtype !== "BR") {
          this.setState({
            plugCalculatorPopupVisible: false
          });
        }
        else {
          this.setState({
            bareRootCalculatorPopupVisible: false
          });
        }
      })
      .catch((err) => {
        alert(err, "Error");
      });
  }

  showPopup() {

    var rowsData = dataGrid.current.instance().getSelectedRowsData();

    if (rowsData != null && rowsData.length > 0) {
      var order = { ...this.state.order }
      order.selecteddetailrowid = rowsData[0].rowid;
      order.selecteddetailissueqty = rowsData[0].issueqty == null ? 0.0 : rowsData[0].issueqty;
      order.selecteddetailbalance = rowsData[0].balance == null ? 0.0 : rowsData[0].balance;
      order.selecteddetailseeditem = rowsData[0].seeditem;
      order.selecteddetailpad = rowsData[0].pad;
      order.selecteddetailseedlot = rowsData[0].seedlot;
      order.selecteddetailgerm = rowsData[0].germ;
      order.selecteddetailpurity = rowsData[0].purity;
      order.selecteddetailcellstosow = rowsData[0].cellstosow;
      order.selecteddetailseedslb = rowsData[0].seedslb;
      order.selectedseedpercell = rowsData[0].seedpercell;
      if (this.state.order.prodtype !== "BR") {
        order.selecteddetailrequired = rowsData[0].required;
      }
      else {
        order.selecteddetailrequired = (this.state.order.orderquantity - rowsData[0].allpktrees) / rowsData[0].pktreeslb;
      }
      order.selecteddetailrevseedslb = rowsData[0].revseedslb;
      order.selecteddetailplsperlb = rowsData[0].plsperlb;
      order.selecteddetailpktreeslb = rowsData[0].pktreeslb;
      order.selecteddetailpktrees = rowsData[0].pktrees;
      order.selecteddetailallpktrees = rowsData[0].allpktrees;
      order.newseedspercell = 0;
      order.selecteddetailnewissueqty = 0;
      this.setState({ order });

      if (this.state.order.prodtype !== "BR") {

        var subject = 'Seed Requirement';
        var emailBody = `Based on your request for ${(this.state.order.orderquantity).toLocaleString()} seedlings for item ${this.state.order.selecteddetailseeditem} with an oversow of ${this.state.order.oversow} we need ${(this.state.order.selecteddetailissueqty + this.state.order.selecteddetailbalance).toLocaleString()} pounds of seed to make order. We are short ${this.state.order.selecteddetailbalance.toLocaleString()} pounds. %0D%0A Production Lot = ${this.state.order.prodlot} %0D%0A Sales Item = ${this.state.order.salesitem} %0D%0A Sales Order = ${this.state.order.salesorder} %0D%0A Seed Item = ${this.state.order.selecteddetailseeditem} %0D%0A Seed Lot = ${this.state.order.selecteddetailseedlot} %0D%0A Tray Type = ${this.state.order.celltype} %0D%0A Germ = ${this.state.order.selecteddetailgerm} %0D%0A Seeds per Lb = ${this.state.order.selecteddetailrevseedslb} %0D%0A`;
        this.setState({
          emailLink: "mailto:?subject=" + subject + "&body=" + emailBody
        });

        this.setState({
          plugCalculatorPopupVisible: true
        });
      }
      else {

        var subject = 'Seed Requirement';
        var emailBody = `Based on your request for ${(this.state.order.orderquantity).toLocaleString()} seedlings for item ${this.state.order.selecteddetailseeditem} with an oversow of ${this.state.order.oversow} we need ${(this.state.order.selecteddetailissueqty + this.state.order.selecteddetailrequired).toLocaleString()} pounds of seed to make order. We are short ${this.state.order.selecteddetailrequired.toLocaleString()} pounds. %0D%0A Production Lot = ${this.state.order.prodlot} %0D%0A Sales Item = ${this.state.order.salesitem} %0D%0A Sales Order = ${this.state.order.salesorder} %0D%0A Seed Item = ${this.state.order.selecteddetailseeditem} %0D%0A Seed Lot = ${this.state.order.selecteddetailseedlot} %0D%0A Germ = ${this.state.order.selecteddetailgerm} %0D%0A Purity = ${this.state.order.selecteddetailpurity} %0D%0A Seeds per Lb = ${this.state.order.selecteddetailseedslb} %0D%0A Oversow = ${this.state.order.oversow} %0D%0A`;
        this.setState({
          emailLink: "mailto:?subject=" + subject + "&body=" + emailBody
        });

        this.setState({
          bareRootCalculatorPopupVisible: true
        });
      }
    }
    else {
      alert("Please select a detail row first.", "Alert");
    }
  }

  hideEGermPopup() {
    this.setState({
      eGermPopupVisible: false
    });
  }

  eGermPopupShowing() {

    var totalbags = Math.floor(this.state.order.newwetweight / this.state.order.poundsperbag) + (this.state.order.newwetweight - (this.state.order.newwetweight / this.state.order.poundsperbag) != 0 ? 1 : 0);
    var order = { ...this.state.order };
    order.totalbags = totalbags;
    this.setState({ order });
    eGermForm.current.instance().repaint();

  }

  hidePlugCalculatorPopup() {
    this.setState({
      plugCalculatorPopupVisible: false
    });
  }

  hideBareRootCalculatorPopup() {
    this.setState({
      bareRootCalculatorPopupVisible: false
    });
  }

  GetOrderData(productionlot) {
    axios
      .get(
        `${window._env_.REACT_APP_APIS}/${routes.master_records.GetMasterOrder}?productionLot=${productionlot}`,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          }
        }
      )
      .then((res) => {

        this.setState({
          order: res.data
        });

        dataGrid.current.instance().refresh();

      })
      .catch((err) => {
        console.log(err, "error in Get Master Order");
      });
  }

  seedItemDataSource(options) {
    var that = this;
    return {
      store: createStore({
        loadUrl: `${window._env_.REACT_APP_APIS}/${routes.master_records.GetSeedItems}`,
        loadParams:
        {
          masterRowId: function () {
            if (that.state != null && that.state != undefined &&
              that.state.order != null && that.state.order != undefined) {
              return that.state.order.rowid;
            }

            return "00000000-0000-0000-0000-000000000000";
          },
          itemCode: function () {
            if (that.state != null && that.state != undefined &&
              that.state.order != null && that.state.order != undefined &&
              that.state.order.speciescode != null && that.state.order.speciescode != undefined) {
              return that.state.order.speciescode;
            }

            return "";
          },
          warehouse: function () {
            if (options != null && options != undefined) {
              if (options.hasOwnProperty('data')) {
                if (options.data != null && options.data != undefined &&
                  options.data.warehouse != null && options.data.warehouse != undefined) {
                  return options.data.warehouse;
                }

                return "";
              }
            }

            return undefined;
          },
          seedItem: function () {
            if (options != null && options != undefined &&
              options.hasOwnProperty('data') && options.data != null && options.data != undefined &&
              options.data.seeditem != null && options.data.seeditem != undefined) {
              return options.data.seeditem;
            }

            return "";
          }
        },

        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        }
      }),
    };
  }

  seedLotDataSource(options) {
    var that = this;
    return {
      store: createStore({
        loadUrl: `${window._env_.REACT_APP_APIS}/${routes.master_records.GetSeedLots}`,
        loadParams:
        {
          masterRowId: function () {
            if (that.state != null && that.state != undefined &&
              that.state.order != null && that.state.order != undefined) {
              return that.state.order.rowid;
            }

            return "00000000-0000-0000-0000-000000000000";
          },
          itemCode: function () {
            if (that.state != null && that.state != undefined &&
              that.state.order != null && that.state.order != undefined &&
              that.state.order.speciescode != null && that.state.order.speciescode != undefined) {
              return that.state.order.speciescode;
            }

            return "";
          },
          warehouse: function () {
            if (options != null && options != undefined) {
              if (options.hasOwnProperty('data')) {
                if (options.data != null && options.data != undefined &&
                  options.data.warehouse != null && options.data.warehouse != undefined) {
                  return options.data.warehouse;
                }

                return "";
              }
            }

            return undefined;
          },
          seedItem: function () {
            if (options != null && options != undefined &&
              options.hasOwnProperty('data') && options.data != null && options.data != undefined &&
              options.data.seeditem != null && options.data.seeditem != undefined) {
              return options.data.seeditem;
            }

            return "";
          },
          seedLot: function () {
            if (options != null && options != undefined &&
              options.hasOwnProperty('data') && options.data != null && options.data != undefined &&
              options.data.seedlot != null && options.data.seedlot != undefined) {
              return options.data.seedlot;
            }

            return "";
          }
        },

        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        }
      }),
    };
  }

  locationDataSource(options) {
    var that = this;
    return {
      store: createStore({
        loadUrl: `${window._env_.REACT_APP_APIS}/${routes.master_records.GetLocations}`,
        loadParams:
        {
          masterRowId: function () {
            if (that.state != null && that.state != undefined &&
              that.state.order != null && that.state.order != undefined) {
              return that.state.order.rowid;
            }

            return "00000000-0000-0000-0000-000000000000";
          },
          itemCode: function () {
            if (that.state != null && that.state != undefined &&
              that.state.order != null && that.state.order != undefined &&
              that.state.order.speciescode != null && that.state.order.speciescode != undefined) {
              return that.state.order.speciescode;
            }

            return "";
          },
          warehouse: function () {
            if (options != null && options != undefined) {
              if (options.hasOwnProperty('data')) {
                if (options.data != null && options.data != undefined &&
                  options.data.warehouse != null && options.data.warehouse != undefined) {
                  return options.data.warehouse;
                }

                return "";
              }
            }

            return undefined;
          },
          seedItem: function () {
            if (options != null && options != undefined &&
              options.hasOwnProperty('data') && options.data != null && options.data != undefined &&
              options.data.seeditem != null && options.data.seeditem != undefined) {
              return options.data.seeditem;
            }

            return "";
          },
          seedLot: function () {
            if (options != null && options != undefined &&
              options.hasOwnProperty('data') && options.data != null && options.data != undefined &&
              options.data.seedlot != null && options.data.seedlot != undefined) {
              return options.data.seedlot;
            }

            return "";
          },
          location: function () {
            if (options != null && options != undefined &&
              options.hasOwnProperty('data') && options.data != null && options.data != undefined &&
              options.data.location != null && options.data.location != undefined) {
              return options.data.location;
            }

            return "";
          }
        },

        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        }
      }),
    };
  }

  setWarehouseValue(rowData, value) {
    rowData.seeditem = null;
    rowData.seedlot = null;
    rowData.location = null;
    if (this.state.order.custtype == "EXTERNAL" && value != "RSFCO") {
      rowData.growingservice = true;
    }
    else {
      rowData.growingservice = false;
    }
    rowData.germ = null;
    rowData.purity = null;
    rowData.seedslb = null;
    rowData.rseedinventory = null;

    var order = { ...this.state.order }

    if (value === "RSFCO") {
      order.seedsource = 'Cust Inv';
    }
    else if (value === "RSFCI") {
      order.seedsource = 'Cust Seed';
    }
    else {
      order.seedsource = 'Weyer Inv';
    }

    this.setState({ order });

    var columns = dataGrid.current.instance().getVisibleColumns();
    var locationColumnIndex = dataGrid.current.instance().getVisibleColumnIndex("warehouse");
    columns[locationColumnIndex].defaultSetCellValue(rowData, value);
  }
  setSeedItemValue(rowData, value) {
    rowData.seedlot = null;
    rowData.location = null;
    rowData.germ = null;
    rowData.purity = null;
    rowData.seedslb = null;
    rowData.rseedinventory = null;
    this.defaultSetCellValue(rowData, value);
  }

  setSeedLotValue(rowData, value) {
    rowData.location = null;
    rowData.germ = null;
    rowData.purity = null;
    rowData.seedslb = null;
    rowData.rseedinventory = null;
    this.defaultSetCellValue(rowData, value);
  }

  setLocationValue(newData, value, currentData) {
    return this.getSeedInventory(value, currentData).then(data => {
      newData.location = value;
      newData.rseedinventory = data.rowid;
      newData.germ = data.germ;
      newData.purity = data.purity;
      newData.seedslb = data.seedslb;
    });

    /*
    newData.location = value;
    this.defaultSetCellValue(newData, value);
    dataGrid.current.instance().saveEditData();
    */

    /*
    var columns = dataGrid.current.instance().getVisibleColumns();
    var locationColumnIndex = dataGrid.current.instance().getVisibleColumnIndex("location");
    columns[locationColumnIndex].defaultSetCellValue(newData, value);
    
    axios.get
      (
        `${window._env_.REACT_APP_APIS}/${routes.master_records.GetSeedInventoryInfo}?itemCode=${this.state.order.speciescode}&warehouse=${currentData.warehouse}&seedItem=${currentData.seeditem}&seedLot=${currentData.seedlot}&location=${value}`,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          },
        }
      )
      .then((res) => {
        if(res != null && res.hasOwnProperty('data') && res.data != null)
        {
          newData.rseedinventory = res.data.rowid;
          newData.germ = res.data.germ;
          var germColumnIndex = dataGrid.current.instance().getVisibleColumnIndex("germ");
          columns[germColumnIndex].defaultSetCellValue(newData, value);
          newData.purity = res.data.purity;
          newData.seedslb = res.data.seedslb;
        }
      })
      .catch((err) => {
        alert(err, "Error");
      });
      */
  }

  getSeedInventory(location, currentData) {
    const encodedSeedLot = encodeURIComponent(currentData.seedlot);
    const encodedSeedItem = encodeURIComponent(currentData.seeditem);
    const encodedSeedLocation = encodeURIComponent(location);
    return axios.get
      (
        `${window._env_.REACT_APP_APIS}/${routes.master_records.GetSeedInventoryInfo}?itemCode=${this.state.order.speciescode}&warehouse=${currentData.warehouse}&seedItem=${encodedSeedItem}&seedLot=${encodedSeedLot}&location=${encodedSeedLocation}`,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken
          },
        }
      )
      .then(res => {
        return res.data;
      })
      .catch(error => { throw "Data Loading Error" });
  }

  getDisplayExpr(item) {
    return (
      <div>
        Test
      </div>
    );
    // return item ? `${item.location} (${item.available})` : '';
  }

  handleProductionLotChanged(value) {
    this.GetOrderData(value.value);
  }

  selectionChanged(e) {

    var data = null;

    if (e.selectedRowsData.length == 2) {
      data = e.selectedRowsData[1];
    }
    else if (e.selectedRowsData.length == 1) {
      data = e.selectedRowsData[0];
    }

    if (customSelection) {
      return;
    }

    customSelection = true;
    e.component.selectRows(e.currentSelectedRowKeys[0], false);
    customSelection = false;

    var order = { ...this.state.order }

    if (data === undefined || data === null) {
      order.selecteddetailchangedissueqty = 0;
      order.selecteddetailavailable = 0;
      order.selecteddetailnetavailable = 0;
      order.selecteddetailchangeqty = 0;
      order.selecteddetailnewavailable = 0;
      order.selecteddetailcurrentqty = 0;
    }
    else {
      order.selecteddetailchangedissueqty = 0;
      order.selecteddetailavailable = data.available;
      order.selecteddetailnetavailable = data.netavailable;
      order.selecteddetailchangeqty = 0;
      order.selecteddetailnewavailable = 0;
      order.selecteddetailcurrentqty = data.issueqty;

    }

    this.setState({ order });

  }

  initNewRow(e) {
    e.data.rmaster = this.state.order.rowid;
    e.data.growingservice = false;
  }

  rowUpdated(e) {
    var order = { ...this.state.order }
    order.issueqtysum = e.data.issueqtysum;
    this.setState({ order });
  }

  rowRemoved(e) {
    var order = { ...this.state.order }
    order.issueqtysum = order.issueqtysum - ((e.data.issueqty == null || e.data.issueqty == undefined) ? 0 : e.data.issueqty);
    this.setState({ order });
  }

  rowInserted(e) {
    var order = { ...this.state.order }
    order.issueqtysum = order.issueqtysum + ((e.data.issueqty == null || e.data.issueqty == undefined) ? 0 : e.data.issueqty);
    this.setState({ order });
  }

  editorPreparing(e) {
    if (e.parentType === "dataRow" && e.hasOwnProperty('row') && e.hasOwnProperty('dataField') && e.hasOwnProperty('editorOptions') &&
      ((!e.row.hasOwnProperty('isNewRow') || e.row.isNewRow === false) && e.row.data.issueqty != 0) &&
      (e.dataField === "warehouse" || e.dataField === "seeditem" || e.dataField === "seedlot" || e.dataField === "location")) {
      e.editorOptions.disabled = true;
    }

    if (e.parentType === 'dataRow' && e.dataField === 'location') {
      e.editorOptions.itemTemplate = (data) => {
        const div = document.createElement('div');
        div.append(data.locationAvailable);
        return div;
      }
    }

  }

  formFieldChanged(e) {

    if (e.dataField === "prodtype") {
      if (this.state.order.prodtype !== "PL" || this.state.order.prodtype !== "BR") {
        alert("Only two values allowed PL for Plug or BR for Bare Root.", "Error");
        e.component.getEditor("prodtype").focus();
        return;
      }
    }

    this.updateMasterOrder(e.dataField);

  }

  eGermFormFieldChanged(e) {

    if (e.dataField === "poundsperbag") {
      var totalbags = Math.floor(this.state.order.newwetweight / this.state.order.poundsperbag) + (this.state.order.newwetweight - (this.state.order.newwetweight / this.state.order.poundsperbag) != 0 ? 1 : 0);
      var order = { ...this.state.order };
      order.totalbags = totalbags;
      this.setState({ order });
      eGermForm.current.instance().repaint();
    }
  }

  isReleasedChanged(e) {
    if (e.event !== null && e.event !== undefined) {
      var order = { ...this.state.order }
      order.isreleased = e.value;
      this.setState({ order });
      this.updateMasterOrder("isreleased");
    }
  }

  releasedDateChanged(e) {
    if (e.event !== null && e.event !== undefined) {
      var order = { ...this.state.order }
      order.releaseddate = e.value;
      this.setState({ order });
      this.updateMasterOrder("releaseddate");
    }
  }

  isLotAssignedChanged(e) {
    if (e.event !== null && e.event !== undefined) {
      var order = { ...this.state.order }
      order.islotassigned = e.value;
      this.setState({ order });
      this.updateMasterOrder("islotassigned");
    }
  }

  lotAssignedDateChanged(e) {
    if (e.event !== null && e.event !== undefined) {
      var order = { ...this.state.order }
      order.lotassigneddate = e.value;
      this.setState({ order });
      this.updateMasterOrder("lotassigneddate");
    }
  }

  isStratPendingChanged(e) {
    if (e.event !== null && e.event !== undefined) {
      var order = { ...this.state.order }
      order.isstratpending = e.value;
      this.setState({ order });
      this.updateMasterOrder("isstratpending");
    }
  }

  stratPendingDateChanged(e) {
    if (e.event !== null && e.event !== undefined) {
      var order = { ...this.state.order }
      order.stratpendingdate = e.value;
      this.setState({ order });
      this.updateMasterOrder("stratpendingdate");
    }
  }

  isOnPullOrderChanged(e) {
    if (e.event !== null && e.event !== undefined) {
      var order = { ...this.state.order }
      order.isonpullorder = e.value;
      this.setState({ order });
      this.updateMasterOrder("isonpullorder");
    }
  }

  onPullOrderDateChanged(e) {
    if (e.event !== null && e.event !== undefined) {
      var order = { ...this.state.order }
      order.onpullorderdate = e.value;
      this.setState({ order });
      this.updateMasterOrder("onpullorderdate");
    }
  }

  pullOrderNumberChanged(e) {
    if (e.event !== null && e.event !== undefined) {
      var order = { ...this.state.order }
      order.pullordernumber = e.value;
      this.setState({ order });
      this.updateMasterOrder("pullordernumber");
    }
  }

  isInWetStratChanged(e) {
    if (e.event !== null && e.event !== undefined) {
      var order = { ...this.state.order }
      order.isinwetstrat = e.value;
      this.setState({ order });
      this.updateMasterOrder("isinwetstrat");
    }
  }

  inWetStratDateChanged(e) {
    if (e.event !== null && e.event !== undefined) {
      var order = { ...this.state.order }
      order.inwetstratdate = e.value;
      this.setState({ order });
      this.updateMasterOrder("inwetstratdate");
    }
  }

  stratRowBayShelfChanged(e) {
    if (e.event !== null && e.event !== undefined) {
      var order = { ...this.state.order }
      order.stratrowbayshelf = e.value;
      this.setState({ order });
      this.updateMasterOrder("stratrowbayshelf");
    }
  }

  isSelectDryLotsChanged(e) {
    if (e.event !== null && e.event !== undefined) {
      var order = { ...this.state.order }
      order.isselectdrylots = e.value;
      this.setState({ order });
      this.updateMasterOrder("isselectdrylots");
    }
  }

  selectDryLotsDateChanged(e) {
    if (e.event !== null && e.event !== undefined) {
      var order = { ...this.state.order }
      order.selectdrylotsdate = e.value;
      this.setState({ order });
      this.updateMasterOrder("selectdrylotsdate");
    }
  }

  selectDryLotsNumberChanged(e) {
    if (e.event !== null && e.event !== undefined) {
      var order = { ...this.state.order }
      order.selectdrylotsnumber = e.value;
      this.setState({ order });
      this.updateMasterOrder("selectdrylotsnumber");
    }
  }

  dryStratCompleteChanged(e) {
    if (e.event !== null && e.event !== undefined) {
      var order = { ...this.state.order }
      order.drystratcomplete = e.value;
      this.setState({ order });
      this.updateMasterOrder("drystratcomplete");
    }
  }

  dryStratCompleteDateChanged(e) {
    if (e.event !== null && e.event !== undefined) {
      var order = { ...this.state.order }
      order.drystratcompletedate = e.value;
      this.setState({ order });
      this.updateMasterOrder("drystratcompletedate");
    }
  }

  shippedDateChanged(e) {
    if (e.event !== null && e.event !== undefined) {
      var order = { ...this.state.order }
      order.shippeddate = e.value;
      this.setState({ order });
      this.updateMasterOrder("shippeddate");
    }
  }

  updateMasterOrder(fieldName) {
    if (this.state !== null && this.state !== undefined &&
      this.state.order !== null && this.state.order !== undefined &&
      this.state.order.rowid !== "00000000-0000-0000-0000-000000000000") {
      this.state.order.fieldname = fieldName;
      axios.put
        (
          `${window._env_.REACT_APP_APIS}/${routes.master_records.UpdateMasterOrder}`,
          this.state.order,
          {
            headers: {
              "Content-Type": "application/json",
              access_token: accessToken,
            },
          }
        )
        .then((res) => {
          if (fieldName == "color" || fieldName == "symbol") {
            if (res.data !== null && res.data !== undefined) {
              var order = { ...this.state.order }
              order.imagedata = res.data;
              this.setState({ order });
              eGermForm.current.instance().repaint();
            }
          }
          else if (fieldName == "sowdate" || fieldName == "wetstratdays" ||
            fieldName == "drystratdays" || fieldName == "selectdrylotsdate" ||
            fieldName == "inwetstratdate") {
            if (res.data) {
              var order = { ...this.state.order }
              order.stratdate = res.data.stratdate;
              order.endstratdate = res.data.endstratdate;
              order.orderduedate = res.data.orderduedate;
              order.stratdays = res.data.stratdays;
              order.drystratdonedate = res.data.drystratdonedate;
              this.setState({ order });
            }
          }
          else if (fieldName == "newwetweight" || fieldName == "orderquantity" || fieldName == "species" || fieldName == "iscut" || fieldName == "pullordernumber" || fieldName == "cutseedspercell") {
            eGermForm.current.instance().repaint();
          }
        })
        .catch((err) => {
          alert(err, "Error");
        });
    }
  }



}

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}

export default connect(mapStateToProps)(MasterOrder);
